import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'ttag';
/**
 * Empty state for a success process.
 *
 * @version 1.0.0
 * @author [Nagy Gergely](https://github.com/gergely-nagy)
 */
const EmptyTypes = (props) => {
  return (
    <div className="empty-state animated fadeIn">
      {props.hasImage && (
        <img
          src={process.env.PUBLIC_URL + '/img/empty_posts.svg'}
          className="img-fluid"
          alt="img-avatar"
          style={{ maxWidth: 100, maxHeight: 100 }}
        />
      )}
      <h3>{/*props.title*/}</h3>
      <p>{props.subtitle}</p>
    </div>
  );
};

EmptyTypes.propTypes = {
  /** boolean to control the image visibility of the SuccessEmptyState */
  hasImage: PropTypes.bool,
  /** function for the button's onClick */
  submitClick: PropTypes.func,
  /** custom title of the SuccessEmptyState */
  title: PropTypes.string,
  /** custom subtitle of the SuccessEmptyState */
  subtitle: PropTypes.string,
  /** custom button title of the SuccessEmptyState */
  btnText: PropTypes.string,
};

// Specifies the default values for props:
EmptyTypes.defaultProps = {
  hasImage: false,
  title: t`Még nem választott jegyet!`,
  subtitle: t`Jegytípus választáshoz jegy kijelölése szükséges.`,
};

export default EmptyTypes;
